<template>
  <div class="recover-password">
    <div class="instructions">
      {{ $t('views.password_recover.instructions') }}
    </div>
    <edudash-input
      v-model="email"
      rules="required|email"
      prepend-icon="mail_outline"
      :name="$t('views.password_recover.email')"
      :label="$t('views.password_recover.email_label')"
    />
    <edudash-input
      v-model="cpf"
      rules="required|cpf"
      prepend-icon="description"
      :name="$t('views.password_recover.cpf')"
      :label="$t('views.password_recover.cpf_label')"
      :mask="cpfMask"
    />
    <v-row>
      <v-col cols="6">
        <edudash-button
          :text="$t('views.password_recover.send')"
          :full-width="true"
          @click="callRecoverPassword"
        />
      </v-col>
    </v-row>

    <dialog-box
      :title="$t('views.password_recover.dialog.title')"
      :text="$t('views.password_recover.dialog.text')"
      :btn-text="$t('views.password_recover.dialog.confirm')"
      :show="emailDialog"
      @confirm="toLogin"
    />
  </div>
</template>

<script>
import EdudashButton from '@/components/forms/EdudashButton.vue';
import EdudashInput from '@/components/forms/EdudashInput.vue';
import DialogBox from '@/components/feedbacks/DialogBox.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'RecoverPassword',
  components: {
    EdudashButton,
    EdudashInput,
    DialogBox,
  },
  data() {
    return {
      email: '',
      cpf: '',
      emailDialog: false,
    };
  },
  computed: {
    ...mapGetters([
      'getRecoverSent',
    ]),
    cpfMask() {
      return '###.###.###-##';
    },
  },
  watch: {
    getRecoverSent(value) {
      if (value) {
        this.emailDialog = true;
        this.changeRecoverSent();
      }
    },
  },
  mounted() {
    this.changeToolbarText(this.$t('views.password_recover.title'));
  },
  methods: {
    ...mapActions([
      'changeToolbarText',
      'recoverPassword',
      'changeRecoverSent',
    ]),
    callRecoverPassword() {
      this.recoverPassword({ cpf: this.unmask(this.cpf), email: this.email });
    },
    toLogin() {
      this.emailDialog = false;
      this.$router.push({ name: 'login' });
    },
  },
};
</script>
<style lang="scss">
.recover-password {
  padding: 10px 16px;

  .instructions {
    margin-bottom: 16px;
      @include font-monteserrat-regular;
      color: $text-color-secondary;
      font-size: $font-size-extra-small;
  }
}
</style>
